/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectedOption/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Autopay from './Autopay/index'
import Invoice from './Invoice/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SelectedOption({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PaymentSources/SelectedOption"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let newPaymentPlanSelectedPaymentSourceValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'selected_payment_source',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: newPaymentPlanSelectedPaymentSourceValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Autopay'}>
<Autopay
  viewPath={`${viewPath}/Autopay`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Invoice'}>
<Invoice
  viewPath={`${viewPath}/Invoice`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}